import React, { useEffect, useState } from "react";
import { winSoundBingo } from "utils/config/reference";
import { captureException } from "@sentry/react";
import { useHowlAudio } from "components/hooks/useHowlProvider";
import loteriaWinGif1 from "../../../utils/assets/images/Lotería_win_gif1.gif";
import loteriaWinGif2 from "../../../utils/assets/images/Lotería_win_gif2.gif";
import loteriaWinGif3 from "../../../utils/assets/images/Lotería_win_gif3.gif";
import loteriaWinGif4 from "../../../utils/assets/images/Lotería_win_gif4.gif";
import loteriaWinGif5 from "../../../utils/assets/images/Lotería_win_gif5.gif";
import loteriaWinGif6 from "../../../utils/assets/images/Lotería_win_gif6.gif";
import loteriaWinGif7 from "../../../utils/assets/images/Lotería_win_gif7.gif";
import loteriaWinGif8 from "../../../utils/assets/images/Lotería_win_gif8.gif";

const BingoTeacherWin = ({ bingoWinnerData }) => {
  const gifs = [
    loteriaWinGif1,
    loteriaWinGif2,
    loteriaWinGif3,
    loteriaWinGif4,
    loteriaWinGif5,
    loteriaWinGif6,
    loteriaWinGif7,
    loteriaWinGif8,
  ];

  const [randomGif, setRandomGif] = useState(null);
  const { playHowl, cleanupHowl  } = useHowlAudio();

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * gifs.length);
    setRandomGif(gifs[randomIndex]);
    const audioConfig = {
      src: [winSoundBingo],
      volume: 0.7,
      html5: true,
      loop: true,
      onError: (error) => {
        captureException(`624 Error in playSound: ${error}`);
        console.error("Error playing audio:", error);
      }
    };
    playHowl(audioConfig,'bingoWinSound');

    return () => {
      cleanupHowl('bingoWinSound')
    };
  }, []);

  return (
    <div>
      <div className="loteria-card-teacher">
        <div className="loteria-content">
          <h2>
            ¡Lotería!
            <br />
            You won!
          </h2>
        </div>
        <div className="winner-name">
          <p>{bingoWinnerData?.user_name}</p>
        </div>
        <div className="loteria-image">
          <img
            src="https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/9dbb1fc7-1fd6-4459-e0ec-c583eb8b8200/public"
            alt="Lotería"
          />
        </div>
      </div>
      <div className="loteria-animation-lose">
        <img src={randomGif} alt="loteria-animation" />
      </div>
    </div>
  );
};

export default BingoTeacherWin;
